module.exports = __webpack_public_path__ + "img/education3.acb90136.jpg";